import React from 'react';
import {observer} from 'mobx-react';
import {FormLayout, Input, Select2, Panel} from 'components';
import {t} from 'shared/core';
import TieredCoverageVolumeForm from './TieredCoverageVolumeForm';

const VolumeRateCoverageForm = observer(({uiState}) => {
  const {currentCoverage, errors} = uiState;

  return (
    <div>
      <Panel.Separator />
      <Panel.Subheader title={t('taxable_benefits.Premium Calculations and Rates')}/>
      <FormLayout>
        <FormLayout.Group>
          <Input value={currentCoverage.coverageRate}
            onChange={e => currentCoverage.merge({coverageRate: e.target.value})}
            label='taxable_benefits.Coverage Rate'
            helpMessage='taxable_benefits.help_text.coverage_rate'
            placeholder='taxable_benefits.placeholder.coverage_rate'
            errorMessage={errors.coverageRate}
          />
          <Input value={currentCoverage.coverageVolumeRate} 
            onChange={e => currentCoverage.merge({coverageVolumeRate: e.target.value})}
            label='taxable_benefits.Coverage Volume Rate'
            helpMessage='taxable_benefits.help_text.coverage_volume_rate'
            placeholder='taxable_benefits.placeholder.coverage_volume_rate'
            errorMessage={errors.coverageVolumeRate}
          />
        </FormLayout.Group>
        <Select2 value={currentCoverage.volumeType}
          onChange={e => uiState.changeVolumeType(e.target.value)}
          label='taxable_benefits.Volume Type'
          helpMessage='taxable_benefits.help_text.volume_type'
          errorMessage={errors.volumeType}>
          <option value='amount'>{t('taxable_benefits.Flat amount')}</option>
          <option value='multiple'>{t('taxable_benefits.Multiple of salary')}</option>
          <option value='tier'>{t('taxable_benefits.Tiered')}</option>
        </Select2>
        {currentCoverage.volumeType === 'amount' &&
          <Input value={currentCoverage.volumeAmount}
            onChange={e => currentCoverage.updateVolumeAmount(e.target.value)}
            label='taxable_benefits.Volume Amount'
            errorMessage={errors.volumeAmount}
          />}
        {currentCoverage.volumeType === 'multiple' &&
          <Input value={currentCoverage.volumeMultiple}
            onChange={e => currentCoverage.merge({volumeMultiple: e.target.value})}
            label='taxable_benefits.Volume Multiple'
            errorMessage={errors.volumeMultiple}
          />}
        {currentCoverage.volumeType === 'tier' && <TieredCoverageVolumeForm uiState={uiState} />}
      </FormLayout>
    </div>
  );
});

export default VolumeRateCoverageForm;
